/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Save_Key_RequiredInputs */



/**
* | output |
* | --- |
* | "The endpoint's host changed. Enter the API key for the new host." |
*
* @param {Private_Models_Save_Key_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_save_key_required = /** @type {((inputs?: Private_Models_Save_Key_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Save_Key_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Host des Endpunkts hat sich geändert. Geben Sie den API-Schlüssel für den neuen Host ein.")
	return /** @type {LocalizedString} */ ("The endpoint's host changed. Enter the API key for the new host.")
});